// extracted by mini-css-extract-plugin
export default {"label":"uwResultModal_label__baWy-","value":"uwResultModal_value__BGP8c"};